// 工厂信息
import { BookingOrderProcessStage } from "@/model/booking-order";

export class FactoryInfos {
  id: string;
  supplierId: string;
  factoryCode: string;
  factoryName: string;
  factoryAddress: string;
  totalDeclarationAmount: number;
  fcr: number;
  purchaseOrderProductInfos: PurchaseOrderProductInfos[];
}
// 工厂产品信息
export class PurchaseOrderProductInfos {
  id: string;
  invoiceDescription: string;
  purchaseOrderNumber: string;
  productNumberPcs: number;
  settlementUnit: string;
  unitPrice: number;
  labelingCharge: number;
  claimCharge: number;
  otherCharge: number;
  settlementUnitPrice: number;
  totalSettlementAmount: number;
  returnSettlementAmount: number;
  totalDeclarationAmount: number;
  deductionAndFilling: number;
  deductionAndFillingRemark: string;
  fcr: number;
  sample: boolean;
  purchaseOrderFee: number;
}
// 工厂产品信息
export class PurchaseOrderProductInfosMore {
  id: string;
  invoiceDescription: string;
  purchaseOrderNumber: string;
  batch: string;
  productNumberPcs: number;
  productNetWeight: number;
  settlementUnit: string;
  unitPrice: number;
  labelingCharge: number;
  claimCharge: number;
  otherCharge: number;
  settlementUnitPrice: number;
  totalSettlementAmount: number;
  returnSettlementAmount: number;
  totalDeclarationAmount: number;
  deductionAndFilling: number;
  deductionAndFillingRemark: string;
  selectUnit: SelectUnit[];
  unit: SelectUnit;
  productNameVersionId: string;
  englishUnit: string;
  productType: string;
}
export class SelectUnit {
  index: number;
  invoiceUnit: string;
  englishUnit: string;
}
// 查看退税资料
export class TaxRefundInfo {
  bookingOrderId: string;
  bookingOrderCode: string;
  customerName: string;
  portOfLoading: string;
  deliveryCountry: string;
  internationalTradeTerms: string;
  currencyUnit: string;
  totalDeclarationAmount: number;
  exchangeRate: string;
  modifiedExchangeRate: string;
  totalDeclarationAmountToRmb: number;
  productTotalAmountToRmb: string;
  productInfos: ProductInfos[];
}
export class ProductInfos {
  declarationDescription: string;
  quantity: number;
  unit: string;
  unitPrice: number;
  totalAmount: number;
  totalAmountToRmb: number;
}

export class ExtraMoneyList {
  canCreateDeliveryTime: string;
  canUpdateDeliveryTime: string;
  code: string;
  createdAt: string;
  customsPackingProblemQuantity: string;
  customsPackingQuantity: string;
  deliveryEndTime: string;
  deliveryStartTime: string;
  factoryDeliveryNoteId: string;
  factoryName: string;
  id: string;
  parentCode: string;
  purchaserName: string;
  receiveListId: string;
  remark: string;
  state: string;
  uploadDate: string;
  warehouseReceiptId: string;
  moneyList: MoneyList[];
  filling: MoneyList;
  deduct: MoneyList;
  choice: boolean;
  dataDestination: string;
  hqPackingListCode: string;
  hqPackingListId: string;
  settlementFilling: string;
  settlementDeduct: string;
  surplusFilling: string;
  surplusDeduct: string;
}

export class MoneyList {
  audit: string;
  hqPackingListId: string;
  id: string;
  remark: string;
  type: string;
  value: number;
}
export class FinancialConfiguration {
  exchangeRateUSD: string;
  merUSD: string;
  exchangeRateEURO: string;
  merEURO: string;

  constructor(exchangeRateUSD: string, merUSD: string, exchangeRateEURO: string, merEURO: string) {
    this.exchangeRateUSD = exchangeRateUSD;
    this.merUSD = merUSD;
    this.exchangeRateEURO = exchangeRateEURO;
    this.merEURO = merEURO;
  }
}
// 查看报关详情-物流员
export class CustomsInfo {
  bookingOrderCode: string;
  bookingOrderId: string;
  currencyUnit: string;
  customerId: string;
  customerName: string;
  customerProductInfoList: CustomerProductInfoList[];
  deliveryConuntry: string;
  destinationCountry: string;
  extrasAmount: number;
  factoryName: string;
  freightAmount: number;
  grossWeight: number;
  insuranceAmount: number;
  internationalTradeTerms: string;
  netWeight: number;
  packingType: string;
  portDischarge: string;
  totalNumberPcs: number;
  tradeCountry: string;
  processStage: BookingOrderProcessStage;
  shippingMark: string;
  departure: string;
  transportation: string;
  addressRemark: string;
}
export class CustomerProductInfoList {
  audit: string;
  hqPackingListId: string;
  id: string;
  remark: string;
  type: string;
  value: number;
  deliveryConuntry: string;
  originCountry: string;
  deliveryCountry: string;
  destinationCountry: string;
  index: number;
  unitPrice: number;
  totalAmount: number;
  unitPriceStr: string;
  totalAmountStr: string;
  hsCode: string;
  declarationDescription: string;
  totalNumberPcs: number;
  firstUnit: string;
  productAddress: string;
  exemption: string;
  otherAddress: string;
}
export class SalesContractOrInvoice {
  invoiceCode: string;
  salesContractCode: string;
  bookingOrderId: string;
  customerAddress: string;
  customerName: string;
  customerTel: string;
  invoiceDate: string;
  packing: string;
  partialShipmentsAndTransshipmentsAllowed: string;
  portOfDestination: string;
  portOfLoading: string;
  productInfos: ProductInfos[];
  sailingSchedule: string;
  salesContractDate: string;
  shippingMarks: string;
  termOfPayment: string;
  currencyUnit: string;
  totalAmount: number;
}
export class ElementsList {
  customsProductName: string;
  englishProductName: string;
  firstUnit: string;
  hsCode: string;
  id: string;
  remark: string;
  secondUnit: string;
  index: number;
}
export class PackingListInfos {
  bookingOrderCode: string;
  bookingOrderId: string;
  currentDate: string;
  customerAddress: string;
  customerName: string;
  customerTel: string;
  productInfoResponses: ProductInfoResponses[];
  prompt: string;
  shippingMarks: string;
  totalGrossWeight: number;
  totalNetWeight: number;
  totalVolume: number;
}
export class ProductInfoResponses {
  englishProductName: string;
  quantity: number;
  unit: string;
  customsPackingQuantity: number;
  customsPackingType: string;
  totalNetWeight: string;
  totalGrossWeight:string
  totalVolumes: "";
  sampleQuantity:number;
}

export class ProductDetail{
  declarationDescription: string;
  guestModel: string;
  hqOrJrNumber: string;
  oeNumber: string;
  refNumber: string;
  totalNumberPcs: number;
  purchaseOrderNumber: string;
  batch: string;
  factoryName: string;
  companyDiscountPrice: number;
  otherAmountDistributePrice: number;
}
